/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IInterviewRateProps {
  rate: {
    months?: Date[];
    interviewRates?: number[];
    rejectionRates?: number[];
  };
  interviewRateWidgetLoader: boolean;
}

export class InterviewRate extends Component<IInterviewRateProps> {
  static propTypes = {
    rate: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      interviewRates: PropTypes.arrayOf(PropTypes.number),
      rejectionRates: PropTypes.arrayOf(PropTypes.number),
    }),
    interviewRateWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    rate: {
      months: [],
      interviewRates: [],
      rejectionRates: [],
    },
  };

  render(): ReactNode {
    const { rate, interviewRateWidgetLoader } = this.props;

    const interviewRateOptions = {
      series: [
        {
          name: "Interview Rate",
          data: rate.interviewRates,
        },
        {
          name: "Rejection Rate",
          data: rate.rejectionRates,
        },
      ],
      options: {
        height: 350,
        colors: ["#402680", "#79D9D9"],

        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },
          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          categories: rate.months.map((date) => date.getTime()),
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "%",
          },
          // labels: {
          //   show: true,
          //   formatter: function (val) {
          //     return val + "%";
          //   },
          // },
        },
        legend: {
          offsetY: 8,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              // I've typed the opts manually because ApexCharts seem to have
              // typed this as 'any' which our lint config doesn't like
              // (at the time of writing, anyway) see
              // https://github.com/apexcharts/apexcharts.js/blob/master/types/apexcharts.d.ts#L744
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper className="animated fadeIn delay-5" id="interview-rate-widget">
          <AnalyticsWidgetLoading
            text="Updating..."
            active={interviewRateWidgetLoader}
          />

          <Timeline
            graphOptions={interviewRateOptions}
            dataTestId="interview-rate-per-sector-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="interview-rate-per-sector-title"
            data-tip="Percentage of candidates granted an interview/rejected after submission."
            data-for="interview-rate-per-sector-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="interview-rate-per-sector-title-tooltip"
              className="tooltip-max-width"
            />
            Interview & Rejection Rate
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    currencySymbol?: string;
    jobPerformanceData: {
      rate: {
        months: Date[];
        interviewRates: number[];
        rejectionRates: number[];
      };
    };
    interviewRateWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  rate: state.employerAnalytics.jobPerformanceData.rate,
  interviewRateWidgetLoader: state.employerAnalytics.interviewRateWidgetLoader,
});

export default connect(mapStateToProps, {})(InterviewRate);
